import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import InvestorType from 'src/entities/InvestorType';
import {
  updateInvestorType,
  UpdateInvestorTypeAction,
  UpdateInvestorTypeSuccess
} from 'src/actions/investor-type/update/UpdateInvestorType.actions';
import * as updateInvestorTypeTypes from 'src/actions/investor-type/update/Types';
import User from 'src/entities/User';
import ConfirmAccreditedInvestorTypeComponent, {
  ConfirmAccreditedInvestorTypeComponentProps
} from './ConfirmAccreditedInvestorType.component';
import {
  changeInvestorType,
  ChangeInvestorTypeAction
} from 'src/actions/investor-type/change-data/ChangeInvestorType.actions';
import LoadingContainer from 'src/modules/commons/loading/Loading.container';
import Person from 'src/entities/Person';
import { history } from 'src/store';

interface State {
  success: boolean;
}

interface StateProps {
  user?: User;
  loggedUserData: number | null;
  activeProfile?: Person;
  investorType?: InvestorType;
  error: boolean;
  errorMessage: {};
}

interface DispatchProps {
  changeInvestorType(investorType: InvestorType):
    ChangeInvestorTypeAction;

  updateInvestorType(personId: number, personType: string, investorType: InvestorType):
    Promise<UpdateInvestorTypeAction>;
}

interface Props extends StateProps, DispatchProps {

}

class ConfirmAccreditedInvestorTypeContainer extends React.Component<Props, State> {

  public state = {
    success: false
  };

  public componentWillReceiveProps(nextProps: StateProps) {
    if (this.props.activeProfile && nextProps.activeProfile &&
      (this.props.activeProfile.id !== nextProps.activeProfile.id ||
        this.props.activeProfile.personType !== nextProps.activeProfile.personType)) {
      history.push('/mi-cuenta/tipo-de-inversor');
    }
  }

  public render(): React.ReactNode {
    return (
      this.props.investorType ?
        <ConfirmAccreditedInvestorTypeComponent {...this.getComponentProps()} /> :
        <LoadingContainer/>
    );
  }

  private handleChange(value: string): void {
    const investor: InvestorType = this.props.investorType!;
    investor.confirmationMessage = value.toUpperCase();
    this.props.changeInvestorType(new InvestorType(investor));
  }

  private handleSubmit(): void {
    this.props.updateInvestorType(
      this.props.activeProfile!.id,
      this.props.activeProfile!.personType,
      this.props.investorType!
    ).then((response: UpdateInvestorTypeSuccess) => {
      if (response.type === updateInvestorTypeTypes.UPDATE_INVESTOR_TYPE_SUCCESS) {
        this.setState({success: true});
      }
    });
  }

  private getComponentProps(): ConfirmAccreditedInvestorTypeComponentProps {
    return {
      investorType: this.props.investorType!,
      handleChange: (value: string) => this.handleChange(value),
      handleSubmit: () => this.handleSubmit(),
      success: this.state.success,
      activeProfile: this.props.activeProfile!,
      errorMessage: this.props.errorMessage
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  changeInvestorType: (investorType: InvestorType):
    ChangeInvestorTypeAction => (
    dispatch(changeInvestorType(investorType))
  ),
  updateInvestorType: (personId: number, personType: string, investorType: InvestorType):
    Promise<UpdateInvestorTypeAction> => (
    dispatch(updateInvestorType(personId, personType, investorType))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  user: state.getUser.user,
  loggedUserData: state.authentication.loggedUserData,
  activeProfile: state.setActiveProfile.activeProfile || state.getUser.activeProfile,
  investorType: state.changeInvestorType.investorType,
  error: state.updateInvestorType.error,
  errorMessage: state.updateInvestorType.errorMessage
});

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmAccreditedInvestorTypeContainer);



// WEBPACK FOOTER //
// ./src/modules/my-account/investor-types/partials/ConfirmAccreditedInvestorType.container.tsx